import CartPaymentPageV2 from './CartPaymentPageV2'

export default CartPaymentPageV2
// eslint-disable-next-line import/export
export * from './CartPaymentPageV2'
